import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  icon: {
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: 4,
    width: theme.spacing(2),
    height: theme.spacing(2),
    backgroundColor: theme.palette.common.white,
    'input:hover ~ &': {
      borderColor: theme.palette.primary.light,
    },
    'input:disabled ~ &': {
      borderColor: '#37429316',
      backgroundColor: theme.palette.grey[100],
    },
  },
  checkedIcon: {
    borderColor: theme.palette.primary.light,
    backgroundColor: theme.palette.primary.light,
    '&:before': {
      display: 'block',
      width: theme.spacing(2),
      height: theme.spacing(2),
      backgroundImage:
        "url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16'%3e%3cpath d='M11.779 5.294a1 1 0 01.08 1.32l-.083.094-4.015 4a1.001 1.001 0 01-1.31.09l-.093-.081-2.055-2a1 1 0 011.3-1.516l.094.082 1.35 1.313 3.317-3.304a1.001 1.001 0 011.415.002z' fill='%23fff' fill-rule='evenodd'/%3e%3c/svg%3e\")",
      backgroundSize: 14,
      content: '""',
    },
  },
  indeterminateIcon: {
    borderColor: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.lighter,
    '&:before': {
      display: 'block',
      width: theme.spacing(2),
      height: theme.spacing(2),
      backgroundImage:
        "url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16'%3e%3cpath d='M11.889 7C12.503 7 13 7.448 13 8c0 .513-.429.936-1.111 1H4.11C3.497 9 3 8.552 3 8c0-.513.429-.936 1.111-1h7.778z' fill='%23374293' fill-rule='evenodd'/%3e%3c/svg%3e\")",
      backgroundSize: 14,
      content: '""',
    },
  },
}))

export default useStyles
